export const bufferStringToJson = (buffer) => {
  const decodedErrorString = String.fromCharCode.apply(null, new Uint8Array(buffer));

  return JSON.parse(decodedErrorString);
};

